import Glide from '@glidejs/glide'

export default function () {
    const carousels = document.querySelectorAll(`.glide`)

    if (carousels.length > 0) {
        Array.prototype.slice.call(carousels).forEach(carousel => {
            let glideCarousel = new Glide(carousel, {
                type: 'carousel',
                startAt: 0,
                perView: 2,
                gap: 32,
                autoplay: 7000,
                hoverpause: true,
                dragThreshold: false,
                swipeThreshold: false,
                breakpoints: {
                    767: {
                        perView: 1,
                        dragThreshold: 120,
                        swipeThreshold: 80
                    },
                    1024: {
                        perView: 2,
                        dragThreshold: false,
                        swipeThreshold: false
                    }
                }
            })

            // show the carousel after it gets built in the dom
            glideCarousel.on('build.after', function () {
                carousel.classList.add(`is-active`)
            })

            glideCarousel.mount()

            // fix for ios bug where clicking on the arrows fire two slides instead of one: https://github.com/glidejs/glide/issues/417
            const arrows = carousel.querySelectorAll(`.glide__arrow`)

            Array.prototype.slice.call(arrows).forEach(arrow => {
                arrow.addEventListener(`click`, (e) => {
                    e.preventDefault()
                    glideCarousel.go(e.target.dataset.glideDir)
                })
            })
        })
    }
}
